export var VERSION = '2.12.2';
//# sourceMappingURL=version.js.map